// extracted by mini-css-extract-plugin
export default {"overlay":"ViewportLoadingOverlay_overlay__52iC3"};